import React from "react";
import { Button } from "@mui/material";

export default function GlobalButton({
  children,
  icon,
  variant = "contained",
  sx = {},
  ...props
}) {
  return (
    <Button
      variant={variant}
      startIcon={icon}
      size="large"
      sx={{
        backgroundColor: variant === "contained" ? "#4F46E5" : "#fff",
        color: variant === "contained" ? "#fff" : "#4F46E5",
        border: variant === "outlined" ? "2px solid #4F46E5" : "none",
        "&:hover": {
          backgroundColor: variant === "contained" ? "#fff" : "#4F46E5",
          color: variant === "contained" ? "#4F46E5" : "#fff",
          border: "2px solid #4F46E5",
        },
        boxShadow: "none",
        fontWeight: 500,
        fontSize: 14,
        borderRadius: "4px",
        textTransform: "uppercase",
        px: 2,
        py: 1,
        minWidth: 140,
        height: 46,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
